import type { ProductLogoSmallProps } from "../types";

export function ProductLogoSmallOrganizationPlanning({
  size = 20,
  color = "#0070C0",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M126 204C126 177.49 147.49 156 174 156H294C320.51 156 342 177.49 342 204V220C342 224.418 338.418 228 334 228H134C129.582 228 126 224.418 126 220V204Z"
        fill={color}
      />
      <path
        d="M294 84C294 117.137 267.137 144 234 144C200.863 144 174 117.137 174 84C174 50.8629 200.863 24 234 24C267.137 24 294 50.8629 294 84Z"
        fill={color}
      />
      <path
        d="M108 408C108 427.882 91.8823 444 72 444C52.1177 444 36 427.882 36 408C36 388.118 52.1177 372 72 372C91.8823 372 108 388.118 108 408Z"
        fill={color}
      />
      <path
        d="M270 408C270 427.882 253.882 444 234 444C214.118 444 198 427.882 198 408C198 388.118 214.118 372 234 372C253.882 372 270 388.118 270 408Z"
        fill={color}
      />
      <path
        d="M420 414C420 427.255 409.255 438 396 438C382.745 438 372 427.255 372 414C372 400.745 382.745 390 396 390C409.255 390 420 400.745 420 414Z"
        fill={color}
      />
      <path
        d="M412 120C416.418 120 420.077 116.387 419.24 112.048C418.185 106.577 416.047 101.343 412.922 96.6661C408.307 89.7592 401.747 84.376 394.073 81.1971C386.398 78.0182 377.953 77.1865 369.806 78.807C361.659 80.4276 354.175 84.4277 348.302 90.3015C342.428 96.1753 338.428 103.659 336.807 111.806C335.186 119.953 336.018 128.398 339.197 136.073C342.376 143.747 347.759 150.307 354.666 154.922C359.343 158.047 364.577 160.185 370.048 161.24C374.387 162.077 378 158.418 378 154V128C378 123.582 381.582 120 386 120H412Z"
        fill={color}
      />
      <path
        d="M414.493 196.476C409.382 183.737 399.291 158.564 391.069 137.93C389.768 134.667 393.006 131.436 396.267 132.74L454.782 156.146C457.986 157.428 458.172 161.894 455.085 163.438L434.075 173.943C433.301 174.33 432.673 174.957 432.286 175.732L421.773 196.757C420.231 199.841 415.777 199.677 414.493 196.476Z"
        fill={color}
      />
      <path
        d="M54 294C54 287.373 59.3726 282 66 282H90V348C90 354.627 84.6274 360 78 360H66C59.3726 360 54 354.627 54 348V294Z"
        fill={color}
      />
      <path d="M216 282V318H90V282H216Z" fill={color} />
      <path
        d="M294 282C300.627 282 306 287.373 306 294V306C306 312.627 300.627 318 294 318H282C275.373 318 270 312.627 270 306V294C270 287.373 275.373 282 282 282H294Z"
        fill={color}
      />
      <path
        d="M348 282C354.627 282 360 287.373 360 294V306C360 312.627 354.627 318 348 318H336C329.373 318 324 312.627 324 306V294C324 287.373 329.373 282 336 282H348Z"
        fill={color}
      />
      <path
        d="M402 282C408.627 282 414 287.373 414 294V306C414 312.627 408.627 318 402 318H390C383.373 318 378 312.627 378 306V294C378 287.373 383.373 282 390 282H402Z"
        fill={color}
      />
      <path
        d="M414 360C414 366.627 408.627 372 402 372H390C383.373 372 378 366.627 378 360V348C378 341.373 383.373 336 390 336H402C408.627 336 414 341.373 414 348V360Z"
        fill={color}
      />
      <path
        d="M216 252C216 245.373 221.373 240 228 240H240C246.627 240 252 245.373 252 252V348C252 354.627 246.627 360 240 360H228C221.373 360 216 354.627 216 348V252Z"
        fill={color}
      />
    </svg>
  );
}
